import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  // Button,
  Modal,
  Input,
} from 'antd';
// import { PlusOutlined } from '@ant-design/icons';

import InfoView from 'components/common/InfoView';

import {
  getProcessingSummaries,
  deleteProcessingSummary,
  updateProcessingSummary,
  addProcessingSummary,
} from '../../redux/actions/ProcessingSummaries';
import { ProcessingSummariesColumns } from '../../components/common/Columns';
import generateQuery, { handleSearch } from '../../util/table';
// import Can from '../../util/can';
// import { PROCESSING_SUMMARIES } from '../../constants/resources';
import useForm from '../../hooks/useForm';
import ProcessingSummaryForm from './ProcessingSummaryForm';

const ProcessingSummaries = () => {
  const dispatch = useDispatch();
  const {
    data,
    loading,
    pageSize,
    currentPage,
    totalItems
  } = useSelector(({ processingSummaries }) => processingSummaries);
  const {
    form,
    onFormOk,
    formVisibility,
    // handleShowModal,
    handleCancel,
    handleEditRecord,
    editableRecord,
  } = useForm();

  useEffect(() => {
    const pagination = `page=${currentPage}&limit=${pageSize}`;
    dispatch(getProcessingSummaries(pagination));
  }, [dispatch]);

  const handleDeletePaymentMethod = (id) => {
    dispatch(deleteProcessingSummary(id));
  };

  const handleOnChange = (pagination, filters, sorter) => {
    dispatch(getProcessingSummaries(generateQuery(pagination, filters, sorter)));
  };

  const props = {
    loading,
    scroll: 'y',
    rowKey: '_id',
    sticky: true,
    pagination: {
      current: currentPage,
      pageSize,
      total: totalItems,
      showSizeChanger: false,
    },
    onChange: handleOnChange,
    columns: ProcessingSummariesColumns(
      handleDeletePaymentMethod,
      handleEditRecord,
    ),
    dataSource: data
      ? data.map((item) => ({ ...item }))
      : [],
  };
  const editable = Object.keys(editableRecord).length !== 0;

  const handleOk = (values) => {
    if (editable) {
      dispatch(updateProcessingSummary(editableRecord._id, values));
    } else {
      dispatch(addProcessingSummary(values));
    }
  };

  return (
    (
      <div>
        <h2 className="title gx-mb-4">Processing Summaries</h2>
        <div className="gx-d-flex justify-content-center">
          {/* <Can I="create" a={PROCESSING_SUMMARIES}>
            <Button
              icon={<PlusOutlined />}
              type="primary"
              onClick={() => handleShowModal()}
              data-testid="add-payment-method"
            >
              Add New
            </Button>

          </Can> */}
          <Input.Search
            placeholder="Search"
            enterButton
            data-testid="search-input"
            onSearch={(value) => handleSearch(
              value,
              dispatch,
              getProcessingSummaries,
              ProcessingSummariesColumns,
            )}
          />
        </div>
        <div className="gx-d-flex justify-content-center">
          <Table className="gx-table-responsive" {...props} />
        </div>
        <Modal
          title={editableRecord ? 'Edit Payment Method' : 'Add Payment Method'}
          open={formVisibility}
          okText={editableRecord ? 'Save' : 'Add'}
          onOk={() => onFormOk(handleOk)}
          confirmLoading={loading}
          onCancel={handleCancel}
        >
          <ProcessingSummaryForm {...{ form }} />
        </Modal>
        <InfoView />
      </div>
    )
  );
};

export default ProcessingSummaries;
